// PATH: src/components/modules/devtools/components/ChangesPreviewDiffDialog.js

import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import RichDiffViewer from "./RichDiffViewer";

/**
 * ChangesPreviewDiffDialog
 *
 * Small, focused component extracted from ChangesPanel.
 * Keeps the parent panel clean while preserving the existing UI/behaviour.
 */
const ChangesPreviewDiffDialog = ({
  open,
  onClose,
  loading,
  error,
  data,
}) => {
  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Preview diff</DialogTitle>
      <DialogContent dividers>
        {loading && (
          <Box
            sx={{
              py: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={24} />
          </Box>
        )}

        {!loading && !!error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}

        {!loading && !error && data && (
          <RichDiffViewer
            diffText={data.diff_text}
            emptyMessage="No diff text stored."
            maxHeight={500}
          />
        )}

        {!loading && !error && !data && (
          <Typography variant="body2" color="text.secondary">
            No diff data available.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangesPreviewDiffDialog;
